import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "./Reveal";

export const Preloader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-surface flex flex-col items-center justify-center gap-7"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.85, ease: EASE }}
        >
          <motion.img
            src="/images/logo-komposition.png"
            alt="Manfred Berglar – Zunftwappen mit Wortmarke, Meisterbetrieb seit 1925"
            className="h-24 md:h-32 w-auto max-w-[86%] object-contain"
            initial={{ opacity: 0, scale: 0.94, y: 14 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE }}
          />
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.35, duration: 0.6 }}
            className="font-mono text-[10px] tracking-[0.35em] uppercase text-golddark font-semibold"
          >
            Manfred Berglar · Malermeister · Seit 1925
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
